<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15DnsSS/tc-custom/9781497687370.jpg?1734034335319" alt="This image is the cover for the book Nightmare in New York, The Executioner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nightmare in New York, The Executioner
      </h1>
      <p class="bookDescription body article font2">
        <b>The Executioner targets New York’s five families, who are about to go political</b><br/><br/> Mack Bolan escapes England unhurt but unarmed, praying for a quiet homecoming. This ex­–Vietnam sniper, whose war against the Mafia has taken him around the globe, should have known better. Four mob heavies surround him as he gets off the plane, but it only takes a moment for the man known as the Executioner to take one of their guns as his own. He fights his way to the helipad and lifts off on a short trip to Midtown. The skies are quiet, but the mob will be waiting when he lands.<br/>  <br/> Injured in his escape, Bolan takes refuge with a trio of kind young women, who nurse him back to health as he discovers a Mafia conspiracy to take control of the nation’s government. His European vacation is over, and it’s time for the Executioner to go to work. <br/><br/> Nightmare in New York <i>is the 7th book in the Executioner series, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Pendleton
      </h2>
      
      <p class="authorDescription body article">Don Pendleton (1927&ndash;1995) was born in Little Rock, Arkansas. He served in the US Navy during World War II and the Korean War. His first short story was published in 1957, but it was not until 1967, at the age of forty, that he left his career as an aerospace engineer and turned to writing full time.&#160;After producing a number of science fiction and mystery novels, in 1969 Pendleton launched his first book in the Executioner saga:&#160;<I>War Against the Mafia</I>.&#160;The series, starring Vietnam veteran Mack Bolan, was so successful that it inspired a new American literary genre, and Pendleton became known as the father of action-adventure.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a75e64c